import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react/enhancers';
import { compose } from '@beef/utils';
import { Card } from "../../Card";
import { selectConvergentData, selectIsConvergent } from "../../store/selectors";
import { Accumulators } from "../MobileTariff/Accumulators";
import { BillingDate } from "../BillingDate";
import { ConvergentTariffTitle } from "./ConvergentTariffTitle";
import { ConvergentAccumulators } from "./ConvergentAccumulators";
import { CONVERGENT_URL } from "./constants";
import { ConvergentAddress } from "./ConvegentAddress";
import { selectBillingDate } from "./store";
var _ConvergentTariff = function _ConvergentTariff(_ref) {
  var billingDate = _ref.billingDate;
  return /*#__PURE__*/React.createElement(Card, {
    color: "secondary",
    href: CONVERGENT_URL,
    size: "m",
    "data-t-id": "components-ConvergentTariff"
  }, /*#__PURE__*/React.createElement(ConvergentTariffTitle, {
    "data-t-id": "components-ConvergentTariff"
  }), /*#__PURE__*/React.createElement(Accumulators, null), /*#__PURE__*/React.createElement(ConvergentAddress, null), /*#__PURE__*/React.createElement(ConvergentAccumulators, null), /*#__PURE__*/React.createElement(BillingDate, {
    billingDate: billingDate,
    isComposeBillingDate: true
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    billingDate: selectBillingDate(state),
    shouldRender: !!selectConvergentData(state) && selectIsConvergent(state)
  };
};
export var ConvergentTariff = compose(connect(mapStateToProps), withRenderFlag)(_ConvergentTariff);